import styled, { css } from 'styled-components';

const variants = {
  primary: css`
    background: var(--ink);
    color: var(--bg);
    &:hover:not(:disabled) {
      background: var(--accent);
    }
  `,
  light: css`
    background: var(--on-night);
    color: var(--ink);
    &:hover:not(:disabled) {
      background: var(--accent);
      color: #fff;
    }
  `,
  ghost: css`
    background: transparent;
    color: var(--ink);
    border-color: var(--line);
    &:hover:not(:disabled) {
      border-color: var(--ink);
    }
  `
};

export const Wrapper = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 50px;
  padding: 0 28px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.25s, color 0.25s, border-color 0.25s,
    transform 0.25s var(--ease);
  ${({ $variant }) => variants[$variant] || variants.primary}

  &:active:not(:disabled) {
    transform: scale(0.97);
  }

  &:disabled {
    opacity: 0.5;
    cursor: progress;
  }
`;
